import * as React from 'react';
import { FunctionComponent } from 'react';
import { translate } from '../../../utils/locale';
import { Flex, IconButton, Label } from 'basecamp';
import { fetchCapped9ReportExcel } from '../../../api/alpineDocsReportAPI';

type Props = {
	mb: number;
	minWidth: number;
	isLoading: boolean;
	setIsLoading?: (isLoading: boolean) => void;
	dataTestPrefix?: string;
	align?: string;
};

const ExportCapped9: FunctionComponent<Props> = ({
	mb,
	minWidth,
	isLoading,
	setIsLoading,
	dataTestPrefix,
	align,
}) => {
	const downloadCapped9Report = async () => {
		setIsLoading?.(true);

		try {
			await fetchCapped9ReportExcel('Capped9Report');
		} finally {
			setIsLoading?.(false);
		}
	};

	const labelDataTest = `${dataTestPrefix ?? ''}FilterBarDownloadCapped9Label`;
	const buttonDataTest = `${dataTestPrefix ?? ''}FilterBarDownloadCapped9Button`;
	const containerDataTest = `${dataTestPrefix ?? ''}FilterBarDownloadCapped9`;

	return (
		<Flex
			dataTest={containerDataTest}
			minWidth={minWidth}
			mb={mb}
			setAs="column"
			withAlign={align ?? 'topCenter'}
		>
			<Label dataTest={labelDataTest}>{translate('shared.filterBar.DOWNLOAD_CAPPED_9')}</Label>
			<IconButton
				setAs="primary"
				withIcon="file-excel"
				onClick={downloadCapped9Report}
				disabled={!!isLoading}
				dataTest={buttonDataTest}
			/>
		</Flex>
	);
};

export default ExportCapped9;
